import './Alert.scss';

export default function Alert ({ msg, ...rest }) {
  return (
    <div class='alert' {...rest}>
      {msg}
    </div>
  )
}